import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Landing from './components/Landing';
import CookieBanner from './components/CookieBanner';
import PrivacyPolicy from './components/PrivacyPolicy';
import Offer from './components/Offer';

function App() {
  const [token, setToken] = useState(localStorage.getItem('khepri_token'));
  const [showLanding, setShowLanding] = useState(!localStorage.getItem('khepri_token'));

  const handleLogin = (newToken, user) => {
    localStorage.setItem('khepri_token', newToken);
    localStorage.setItem('khepri_user', JSON.stringify(user));
    setToken(newToken);
    setShowLanding(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('khepri_token');
    localStorage.removeItem('khepri_user');
    setToken(null);
    setShowLanding(true);
  };

  const handleStart = () => {
    setShowLanding(false);
  };

  return (
    <Router>
      <CookieBanner />
      <Routes>
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/offer" element={<Offer />} />
        <Route path="/login" element={!token ? <Login onLogin={handleLogin} /> : <Navigate to="/" />} />
        <Route path="/*" element={token ? <Dashboard onLogout={handleLogout} /> : showLanding ? <Landing onStart={handleStart} /> : <Login onLogin={handleLogin} />} />
      </Routes>
    </Router>
  );
}

export default App;